// Stimulus controller registry. Register per-feature controllers here as the
// app grows; the scaffold ships only the generated `hello` example.

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
